import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const sizes = [
  ["XXS", "78–82", "60–64", "86–90"],
  ["XS", "82–86", "64–68", "90–94"],
  ["S", "86–90", "68–72", "94–98"],
  ["M", "90–96", "72–78", "98–104"],
  ["L", "96–102", "78–84", "104–110"],
  ["XL", "102–108", "84–90", "110–116"],
  ["2XL", "108–116", "90–98", "116–124"],
];

function SizeGuide() {
  useEffect(() => { document.title = `Size guide | ${siteConfig.brandName}`; }, []);

  return (
    <main className="policy-page">
      <header className="policy-hero policy-hero--sand">
        <nav aria-label="Breadcrumb"><Link to="/">Home</Link><span>/</span><span>Size guide</span></nav>
        <p className="eyebrow">Find your fit</p>
        <h1>Size guide</h1>
        <p>Body measurements and practical guidance for choosing a comfortable size.</p>
      </header>
      <div className="policy-layout">
        <aside aria-label="On this page"><a href="#size-measure">How to measure</a><a href="#size-chart">Size chart</a><a href="#size-fit">Fit notes</a><a href="#size-help">Need help?</a></aside>
        <article>
          <section id="size-measure"><p className="eyebrow">01</p><h2>How to measure</h2><ul><li><strong>Bust:</strong> measure around the fullest part while keeping the tape level.</li><li><strong>Waist:</strong> measure around the natural waist without pulling the tape tight.</li><li><strong>Hip:</strong> measure around the fullest part of the seat with feet together.</li></ul><p>Measurements below are body measurements in centimetres, not garment dimensions.</p></section>
          <section id="size-chart"><p className="eyebrow">02</p><h2>Women’s body measurements</h2><div className="policy-table-wrap"><table className="policy-table"><thead><tr><th>Size</th><th>Bust</th><th>Waist</th><th>Hip</th></tr></thead><tbody>{sizes.map(([size, bust, waist, hip]) => <tr key={size}><th>{size}</th><td>{bust}</td><td>{waist}</td><td>{hip}</td></tr>)}</tbody></table></div></section>
          <section id="size-fit"><p className="eyebrow">03</p><h2>Fit notes</h2><p>Each product page describes the intended fit and available sizes. If you fall between sizes, choose the larger size for a relaxed result or the smaller size for a closer result. One-size accessories include their dimensions in the product details.</p><div className="policy-callout">Fit guidance is indicative. Fabric stretch, cut and personal preference can change how a piece feels.</div></section>
          <section id="size-help"><p className="eyebrow">04</p><h2>Need help?</h2><p>Send the product name and your fit question to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p></section>
        </article>
      </div>
    </main>
  );
}

export default SizeGuide;
